import { render, staticRenderFns } from "./RentalIncome.vue?vue&type=template&id=72f9df4c&scoped=true&"
import script from "./RentalIncome.vue?vue&type=script&lang=js&"
export * from "./RentalIncome.vue?vue&type=script&lang=js&"
import style0 from "./RentalIncome.vue?vue&type=style&index=0&id=72f9df4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9df4c",
  null
  
)

export default component.exports